export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'FR',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/fr-fr#brand`,
    'name': 'Timberland',
    'description': 'Timberland est une marque conçue pour les audacieux. Nous inspirons et équipons les personnes en quête d\'aventure afin d\'explorer le monde extérieur, travailler dur et faire avancer le monde.',
    'url': `https://${host}/fr-fr`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '0800.919.142',
      'contactType': 'Telephone',
      'areaServed': 'FR',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 CET'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'FR',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 CET',
      'url': `https://${host}/fr-fr`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/fr-fr`
})
